<template>
    <el-dialog 
      :visible="dialogVisible" 
      :append-to-body="true" 
      v-loading="loading" 
      title="" 
      @close="cancel">

      <div :class="$style['delay']">
          <pt-sub-title title="改派任务">
          </pt-sub-title>

          <pt-form-item label="原实验员：" :labelWidth="labelWidth">
            <div :class="$style['box']">
              <p v-for="(item,i) in taskDatas" :key="i">
                <span>{{item.labTester.name}}</span>
                <span>|</span>
                <span>任务单  {{item.serialNumber}}</span>
              </p>
            </div>
          </pt-form-item>
          <pt-form-item label="新实验员：" :labelWidth="labelWidth" :required="true">
             <lab-staff-selector v-model="form.labTester" data-vv-as="新实验员" v-validate="'required'" @getObj="val=>currentTester =val"></lab-staff-selector>
          </pt-form-item>
      </div>
      <div :class="$style['button-div']">
          <el-button type="primary" @click="submit">确认</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
</template>
<script>
import {
  validate
} from 'utils/validate'
import labStaffSelector from 'cps/selector/lab-staff-selector.vue'
export default {
  name: 'task-reassign-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    taskDatas: {
      type: Array,
      default: ()=>[]
    },
  },
  data () {
    return {
      labelWidth:"120px",
      loading:false,
      form:{},
      currentTester:{},
    }
  },
  components:{labStaffSelector},
  watch: {
   
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    submit(){
      this.formValidata().then((form)=>{
        console.log('-succ',form)
        const {label,value,signatureImageUrl} = this.currentTester
        this.loading = true
        let data = {
          billId:this.taskDatas[0].billId,
          ids:this.taskDatas.map(e=>e.id),
          newLabTester:{
            name:label,
						organizationUserId:value,
						signatureImageUrl:signatureImageUrl
          }
        }
        this.$store.dispatch('taskReassgin', data).then(res => {
          this.$message.success('操作成功')
          this.$emit('reload')
          this.cancel()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(()=>{
          this.loading = false
        })
      })
    },
    cancel () {
      this.$emit('close')
    },
    
  }
}
</script>
<style module lang="less">
  .box{
    >p{
      display: flex;
      span:nth-child(2){
        margin: 0 10px;
      }
    }
  }
  .button-div{
  margin-top: 40px;
  }
</style>
